/* eslint-disable react/require-default-props */
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { VIEW_MODE } from '../../../consts/enums';
import { Linkedin } from '../../../icons/linkedin';
import STRING_KEYS from '../../../language/keys';
import { ChangeCompanyButton } from '../../../pages/AccountEditPanel/ChangeCompanyButton';
import { CompanyFallback } from '../../common/avatars/CompanyFallback';
import { UploadImage } from '../../common/avatars/UploadImage';
import { CustomTooltip } from '../../CustomTooltip';
import { style } from './style';

type AssociatedCompanySectionProps = {
  logo: string,
  name: string,
  onInputUploadImage?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  isDisabled: boolean,
  isLoading: boolean,
  linkedinUrl?: string,
  showIconLinkedin: boolean,
  viewMode: ViewMode,
  onCompanyChangeClick?: () => void,
  isAssociatedCompany?: boolean,
}

export const AssociatedCompanySection = ({
  logo,
  name,
  onInputUploadImage = () => null,
  isDisabled,
  isLoading,
  linkedinUrl = '',
  showIconLinkedin,
  viewMode,
  onCompanyChangeClick = () => null,
  isAssociatedCompany = false,
}: AssociatedCompanySectionProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const isReadOnly = viewMode === VIEW_MODE.READ_ONLY;
  const renderAvatar = () => {
    if (isReadOnly && logo.length === 0) {
      return (
        <Box sx={ style.fallBack.sx }>
          <CompanyFallback width="56px" height="56px" />
        </Box>
      );
    }

    return (
      <UploadImage
        isDisabled={ isDisabled }
        isLoading={ isLoading }
        handleInputUploadImage={ onInputUploadImage }
        alt={ logo }
        profileImage={ logo }
      />
    );
  };

  return (
    <Box sx={ style.rowContainer.sx }>
      <Box sx={ style.row.sx }>
        <Box>
          {renderAvatar()}
        </Box>
        <Box>
          <Typography variant="body2"
            sx={ style.typography }
            fontWeight={ style.typography.fontWeight }
          >
            {translate(STRING_KEYS.ACCOUNTS_ASSOCIATED_COMPANY)}
          </Typography>

          <Box sx={ style.row.linkedinBox.sx }>
            <CustomTooltip title={ name }>
              <Box sx={ style.boxNameCompany.sx } >
                { name }
              </Box>
            </CustomTooltip>
            {showIconLinkedin && (
              <a
                href={ linkedinUrl }
                target="_blank"
                rel="noreferrer"
                style={ style.row.linkedinBox.link }
              >
                <Linkedin />
              </a>
            )}
          </Box>
        </Box>
      </Box>
      {isAssociatedCompany && typeof onCompanyChangeClick === 'function' && (
        <ChangeCompanyButton onCompanyChangeClick={ onCompanyChangeClick } />
      )}
    </Box>
  );
};
